export function preserveAdminHash() {
  const currentHash = window.location.hash;
  if (!currentHash || !window.location.pathname.startsWith("/admin")) return;

  for (const link of document.querySelectorAll("a[href]")) {
    const target = new URL(link.href, window.location.href);
    if (target.origin !== window.location.origin || !target.pathname.startsWith("/admin") || target.hash) continue;
    target.hash = currentHash;
    link.href = target.href;
  }
}

export function startModelHealth() {
  const panel = document.querySelector("#model-health");
  const button = document.querySelector("#model-health-check");
  const results = document.querySelector("#model-health-results");
  if (!panel || !button || !results) return;

  button.addEventListener("click", async () => {
    button.disabled = true;
    button.textContent = "Checking…";
    results.replaceChildren(Object.assign(document.createElement("p"), { textContent: "Contacting NOAA data sources…" }));
    try {
      const response = await fetch(panel.dataset.url, {
        credentials: "same-origin",
        cache: "no-store",
        headers: { "X-CSRF-Token": panel.dataset.csrfToken || "" },
      });
      const payload = await response.json();
      const summary = document.createElement("p");
      summary.className = `model-health-summary model-health-summary--${payload.status}`;
      summary.textContent = `Overall status: ${payload.status}. ${payload.ok ? "All checked sources are responding." : "One or more sources are unavailable."}`;
      const list = document.createElement("ul");
      list.className = "model-health-list";
      for (const model of payload.models ?? []) {
        const item = document.createElement("li");
        item.className = "model-health-item";
        const name = document.createElement("strong");
        const lakeNames = (model.lakes ?? []).map((lake) => lake[0].toUpperCase() + lake.slice(1)).join(", ");
        name.textContent = model.label || `${model.model}${lakeNames ? ` · ${lakeNames}` : ""}`;
        const detail = document.createElement("span");
        const status = model.statusCode === null
          ? `No HTTP response${model.error ? ` · ${model.error}` : ""}`
          : `HTTP ${model.statusCode}${model.reason ? ` ${model.reason}` : ""}`;
        const message = model.message || (model.statusCode !== null && model.statusCode >= 400 ? model.error : "");
        detail.textContent = `${model.up ? "Up" : "Down"} · ${status} · ${model.responseTimeMs} ms${message ? ` · ${message}` : ""}`;
        item.append(name, document.createElement("br"), detail);
        list.append(item);
      }
      if (!response.ok && !payload.models) throw new Error(payload.error || `Status check failed (HTTP ${response.status}).`);
      results.replaceChildren(summary, list);
    } catch (error) {
      const notice = document.createElement("p");
      notice.className = "render-notice render-notice--error";
      notice.textContent = error.message || "Could not check NOAA model status.";
      results.replaceChildren(notice);
    } finally {
      button.disabled = false;
      button.textContent = "Check again";
    }
  });
}
